import React from "react";
// Material Imports
import { makeStyles } from "@material-ui/core/styles"; // Limitless imports

import DialogueBody from "../../dialogue-body/DialogueBody";
var useStyles = makeStyles(function (_ref) {
  var _palette$dialogues$cu, _palette$dialogues, _palette$dialogues$cu2, _palette$dialogues$cu3, _palette$dialogues2, _palette$dialogues2$c, _palette$dialogues$cu4, _palette$dialogues3, _palette$dialogues3$c;

  var palette = _ref.palette;
  var background = (_palette$dialogues$cu = (_palette$dialogues = palette.dialogues) === null || _palette$dialogues === void 0 ? void 0 : (_palette$dialogues$cu2 = _palette$dialogues.customer) === null || _palette$dialogues$cu2 === void 0 ? void 0 : _palette$dialogues$cu2.background) !== null && _palette$dialogues$cu !== void 0 ? _palette$dialogues$cu : palette.primary.light;
  var text = (_palette$dialogues$cu3 = (_palette$dialogues2 = palette.dialogues) === null || _palette$dialogues2 === void 0 ? void 0 : (_palette$dialogues2$c = _palette$dialogues2.customer) === null || _palette$dialogues2$c === void 0 ? void 0 : _palette$dialogues2$c.text) !== null && _palette$dialogues$cu3 !== void 0 ? _palette$dialogues$cu3 : palette.primary.dark;
  var borderRadius = (_palette$dialogues$cu4 = (_palette$dialogues3 = palette.dialogues) === null || _palette$dialogues3 === void 0 ? void 0 : (_palette$dialogues3$c = _palette$dialogues3.customer) === null || _palette$dialogues3$c === void 0 ? void 0 : _palette$dialogues3$c.borderRadius) !== null && _palette$dialogues$cu4 !== void 0 ? _palette$dialogues$cu4 : 12;
  return {
    primaryBackground: {
      backgroundColor: background
    },
    customerTextStyling: {
      color: text
    },
    customerDialouge: {
      display: "flex",
      marginRight: 5,
      position: "relative",
      borderRadius: borderRadius,
      padding: 16,
      flexDirection: "column",
      marginLeft: "auto",
      maxWidth: "75%"
    }
  };
});

var CustomerDialogueBody = function CustomerDialogueBody(_ref2) {
  var body = _ref2.body;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.customerDialouge, " ").concat(classes.primaryBackground)
  }, /*#__PURE__*/React.createElement(DialogueBody, {
    body: body,
    textStyling: classes.customerTextStyling
  }));
};

export default CustomerDialogueBody;